<div [formGroup]="form"  class="mb-6">
    <label [for]="label" class="block text-surface-900 dark:text-surface-0 text-xl font-medium">{{label}}</label>

    <p-select appendTo="body"  [filter]="options && options.length > 5" filterBy="label" [options]="options" [formControlName]="field" [checkmark]="true" optionLabel="label" optionValue="code" [showClear]="true"  [placeholder]="placeholder" class="w-full" />
    @if (form.controls[field].invalid && (form.controls[field].dirty || form.controls[field].touched)) {
        <div class="alert alert-danger">
        @if (form.controls[field].hasError('required')) {
            <p-message severity="error" variant="simple" size="small">
                {{label}} is required.
            </p-message>
            
        }
        @if (form.controls[field].hasError('otherTypeRequired')) {
            <p-message severity="error" variant="simple" size="small">
               {{label}} is required. 
            </p-message>
            
        }

        </div>
    }

</div>